export const displaySum = (props: { value?: number | null; currency: string }) => {
  return `${(props.value ?? 0).toLocaleString()} ${props.currency}`;
};
